const RESERVATION_STATUS = {
  FREE: 'free',
  RESERVATION: 'reservation',
  PENDING_CASHOUTS: 'pending_cashouts',
  SIGNED_CONTRACT: 'signed_contract',
  SOLD: 'bought',
};

export default RESERVATION_STATUS;
